/** Main SHORTED mark (Next-optimized asset on shorted.in). */
export const SHORTED_LOGO_URL =
  "https://shorted.in/_next/image/?q=75&url=%2Fimages%2Fscreening%2Flogo_black.png&w=750";
